import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useFormik } from 'formik';
import type { TFunction } from 'i18next';

import {
  errorToastMessage,
  successToastMessage,
} from '../../../components/layout/toast-root/toast';
import { useFirebaseAuth } from '../../../hooks/useFirebaseAuth';
import { useGetMyDetails } from '../../../services/redux/api/usersApi';
import { FirebaseErrorCodes } from '../../../shared/constants';
import { Paths } from '../../../shared/paths';
import { getChangePasswordFormValidation } from './FormikData';

export function useChangePasswordComponent() {
  const { changePassword } = useFirebaseAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const { data: user } = useGetMyDetails();

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: getChangePasswordFormValidation(t),
    initialValues: { password: '', confirmPassword: '', currentPassword: '' },
    onSubmit: submit,
  });

  async function submit(values: { currentPassword: string; password: string }) {
    try {
      await changePassword(user.email, values.currentPassword, values.password);

      successToastMessage(t('changePassword.successChangePasswordMessage'));
      navigate(Paths.root);
    } catch (error: any) {
      console.error('Change password error message: ', error);
      if (FirebaseErrorCodes.includes(error.code)) {
        errorToastMessage(t(`error.${error.code}`));

        return;
      }
      errorToastMessage(t('error.somethingWentWrong'));
    }
  }

  return { formik, showPassword, setShowPassword };
}
